

import messages from 'vuetify/src/locale/en.ts'

export default messages
